import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { Formula, RegularBenefitVariant } from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuiteFormula(intl: IntlShape) {
  return create(({ expression, type }: Formula) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.Formula, () => {
      test('expression', $t(validation.required), () => {
        enforce(expression).isNotEmpty()
      })
    })
  })
}
